import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    IconButton,
    Tooltip,
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton as MuiIconButton,
} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import HistoryIcon from '@mui/icons-material/History';
import CloseIcon from '@mui/icons-material/Close';
import { SURVEYS_RESPONSES_DETAIL } from '../../../../../routes/paths';
import { SurveyResponseLogs } from '../logs';
import { asyncGetSurveyResponseLogs } from '../../../../../services/survey.service';

interface SurveyResponseListActionsProps {
    id: string;
    onRefresh: () => void;
}

export const SurveyResponseListActions = ({
    id,
}: SurveyResponseListActionsProps) => {
    const navigate = useNavigate();
    const [showLogsModal, setShowLogsModal] = useState(false);
    const [logs, setLogs] = useState<any[]>([]);
    const [loadingLogs, setLoadingLogs] = useState(false);

    const handleViewDetail = () => {
        navigate(SURVEYS_RESPONSES_DETAIL.replace(':id', id));
    };

    const handleViewLogs = async () => {
        setShowLogsModal(true);
        if (logs.length === 0) {
            setLoadingLogs(true);
            try {
                const data = await asyncGetSurveyResponseLogs(id);
                setLogs(data);
            } catch (error) {
                console.error('Error loading logs:', error);
            } finally {
                setLoadingLogs(false);
            }
        }
    };

    const handleCloseLogsModal = () => {
        setShowLogsModal(false);
    };

    return (
        <>
            <Tooltip title="Ver Detalle">
                <IconButton
                    size="small"
                    color="primary"
                    onClick={handleViewDetail}
                >
                    <VisibilityIcon
                        fontSize="small"
                        sx={{ color: 'primary.main' }}
                    />
                </IconButton>
            </Tooltip>
            <Tooltip title="Ver Historial">
                <IconButton size="small" color="info" onClick={handleViewLogs}>
                    <HistoryIcon
                        fontSize="small"
                        sx={{ color: 'primary.main' }}
                    />
                </IconButton>
            </Tooltip>

            <Dialog
                open={showLogsModal}
                onClose={handleCloseLogsModal}
                maxWidth="lg"
                fullWidth
            >
                <DialogTitle>
                    Historial de Cambios
                    <MuiIconButton
                        aria-label="close"
                        onClick={handleCloseLogsModal}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </MuiIconButton>
                </DialogTitle>
                <DialogContent dividers>
                    {loadingLogs ? (
                        <div>Cargando historial...</div>
                    ) : (
                        <SurveyResponseLogs
                            historical={logs}
                            showHistorical={true}
                            responseId={id}
                        />
                    )}
                </DialogContent>
            </Dialog>
        </>
    );
};
